// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/companies/{OrgId}/departments",
  Detail: "/pyr/companies/{OrgId}/departments",
  ListShort: "/pyr/companies/{OrgId}/departments/short",
  Create: "/pyr/companies/{OrgId}/departments",
  Update: "/pyr/companies/{OrgId}/departments",
};
